import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { httpSendReminderEmail } from '../../../../../Hooks/user/user.post.hooks';
import SecondaryButton from '../../../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../../../CreateRoutes/CreateForm.styles';

const SendReminderEmailButton = ({ userId, courseId }) => {
  // const [reminderDate, setReminderDate] = useState('');
  let reminderDate = null;
  const [status, setStatus] = useState('');

  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus('Sending email...');
    const course = { courseId, userId, reminderDate: reminderDate || null };
    const response = await httpSendReminderEmail(course);
    const data = await response.json();
    if (response.ok) {
      setStatus(data.msg || 'Email sent successfully');
    } else {
      setStatus(data.msg || 'Failed to send email');
    }
  };

  return (
    <>
      <h3>Send a Reminder Email</h3>
      <p>Date selection coming soon</p>
      {/* <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <label>Select a date to send the reminder email:</label>
        <input
          style={{ width: '50%' }}
          type="date"
          id="reminderDate"
          name="reminderDate"
          value={reminderDate}
          onChange={(e) => setReminderDate(e.target.value)} // Set the reminderDate state
        />
      </div>
      <p>
        The email will not be sent if the user completes the course before the
        selected date.
      </p> */}
      <SubmitContainer>
        <TopSubmit>
          {status.length > 0 && <p className="result">{status}</p>}
        </TopSubmit>
        <BottomSubmit>
          <SecondaryButton
            span="Send Reminder Email"
            functionName={sendEmail}
          />
        </BottomSubmit>
      </SubmitContainer>
    </>
  );
};

SendReminderEmailButton.propTypes = {
  userId: PropTypes.string.isRequired,
  courseId: PropTypes.string.isRequired,
};

export default SendReminderEmailButton;
